import { Link } from "react-router-dom";
import styles from "./FeaturesHero.module.css";

/* ── Sidebar nav items ─────────────────────────────────── */
const sideLinks = [
  {
    label: "Dashboard",
    active: true,
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
      </svg>
    ),
  },
  {
    label: "Candidates",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
  {
    label: "Matching",
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    ),
  },
  {
    label: "Insights",
    icon: (
      <svg viewBox="0 0 24 24">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    ),
  },
];

const sideLinks2 = [
  {
    label: "Outreach",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    ),
  },
  {
    label: "Assessments",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M9 11l3 3L22 4" />
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
      </svg>
    ),
  },
];

/* ── Pipeline candidates ───────────────────────────────── */
const pipeline = [
  {
    av: "av1",
    init: "A",
    name: "Adaeze Okonkwo",
    sub: "Lagos · 5y exp · Verified",
    score: "96%",
    stage: "Shortlist",
    stageColor: "green",
  },
  {
    av: "av2",
    init: "M",
    name: "Michael Adeyemi",
    sub: "Abuja · 4y exp · Verified",
    score: "93%",
    stage: "Shortlist",
    stageColor: "green",
  },
  {
    av: "av3",
    init: "K",
    name: "Kwame Mensah",
    sub: "Accra · 3y exp · Verified",
    score: "89%",
    stage: "Review",
    stageColor: "",
  },
  {
    av: "av4",
    init: "N",
    name: "Nadia Ibrahim",
    sub: "Nairobi · 4y exp · Verified",
    score: "85%",
    stage: "Assess",
    stageColor: "amber",
  },
];

export default function FeaturesHero() {
  return (
    <header className={styles.hero}>
      <div className={styles.container}>
        {/* Text block */}
        <div className={styles.heroInner}>
          <span className={styles.eyebrow}>
            <span className={styles.dot} />
            Features
          </span>
          <h1 className={styles.heroTitle}>
            Everything you need to{" "}
            <span className={styles.accent}>hire smarter.</span>
          </h1>
          <p className={styles.heroSub}>
            From AI insights to verified talent, Awasource gives you the tools
            to make better hiring decisions — without the screening fatigue.
          </p>
          <div className={styles.heroActions}>
            <Link
              to="/register"
              className={`${styles.btn} ${styles.btnPrimary} ${styles.btnLg}`}
            >
              Get Started
            </Link>
            <a
              href="/#pricing"
              className={`${styles.btn} ${styles.btnSecondary} ${styles.btnLg}`}
            >
              Explore features
            </a>
          </div>
        </div>

        {/* ── Product UI mock ── */}
        <div className={styles.productMock}>
          {/* Window chrome bar */}
          <div className={styles.mockBar}>
            <i className={styles.dot1} />
            <i className={styles.dot2} />
            <i className={styles.dot3} />
            <span className={styles.url}>
              app.awasource.com / hiring · Senior Product Designer
            </span>
          </div>

          {/* Dashboard layout */}
          <div className={styles.dash}>
            {/* Sidebar */}
            <aside className={styles.dashSide}>
              {sideLinks.map((l) => (
                <div
                  key={l.label}
                  className={`${styles.sideLink} ${l.active ? styles.sideLinkActive : ""}`}
                >
                  {l.icon}
                  {l.label}
                </div>
              ))}
              <div className={styles.sideSection}>Pipeline</div>
              {sideLinks2.map((l) => (
                <div key={l.label} className={styles.sideLink}>
                  {l.icon}
                  {l.label}
                </div>
              ))}
            </aside>

            {/* Main area */}
            <div className={styles.dashMain}>
              {/* Stats */}
              <div className={styles.statGrid}>
                <div className={styles.statCard}>
                  <div className={styles.statLabel}>Active candidates</div>
                  <div className={styles.statVal}>
                    128 <small className={styles.delta}>↑ 24%</small>
                  </div>
                </div>
                <div className={styles.statCard}>
                  <div className={styles.statLabel}>Avg. match score</div>
                  <div className={styles.statVal}>
                    82% <small className={styles.delta}>↑ 6pt</small>
                  </div>
                </div>
                <div className={styles.statCard}>
                  <div className={styles.statLabel}>Time to shortlist</div>
                  <div className={styles.statVal}>
                    2.4d{" "}
                    <small className={`${styles.delta} ${styles.deltaDown}`}>
                      ↓ 41%
                    </small>
                  </div>
                </div>
              </div>

              {/* Pipeline table */}
              <div className={styles.pipeline}>
                <div className={styles.pipeHead}>
                  <h4>Top matches · Senior Product Designer</h4>
                  <span className={styles.filter}>Sorted by match score</span>
                </div>
                {pipeline.map((c) => (
                  <div key={c.name} className={styles.candRow}>
                    <div className={`${styles.candAv} ${styles[c.av]}`}>
                      {c.init}
                    </div>
                    <div className={styles.candInfo}>
                      <b>{c.name}</b>
                      <span>{c.sub}</span>
                    </div>
                    <div className={styles.pipScore}>{c.score}</div>
                    <div
                      className={`${styles.pipStage} ${
                        c.stageColor === "green"
                          ? styles.stageGreen
                          : c.stageColor === "amber"
                            ? styles.stageAmber
                            : ""
                      }`}
                    >
                      {c.stage}
                    </div>
                    <div className={styles.pipAction}>View →</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right rail */}
            <aside className={styles.dashRail}>
              {/* Candidate fit ring */}
              <div className={styles.railCard}>
                <div className={styles.railTitle}>Candidate fit</div>
                <div className={styles.ringMini}>
                  <svg viewBox="0 0 64 64" aria-hidden="true">
                    <defs>
                      <linearGradient id="ringGrad" x1="0" x2="1" y1="0" y2="1">
                        <stop offset="0%" stopColor="#2D6BFF" />
                        <stop offset="100%" stopColor="#5B8AFF" />
                      </linearGradient>
                    </defs>
                    <circle
                      className={styles.ringTrack}
                      cx="32"
                      cy="32"
                      r="26"
                    />
                    <circle
                      className={styles.ringFill}
                      cx="32"
                      cy="32"
                      r="26"
                    />
                  </svg>
                  <div>
                    <b>96%</b>
                    <span>Strong match</span>
                  </div>
                </div>
              </div>

              {/* AI insights */}
              <div className={styles.railCard}>
                <div className={styles.railTitle}>AI insights</div>
                <div className={styles.insightRow}>
                  <span className={styles.insightDot}>✓</span>
                  <span>
                    <b>Top 5%</b> in user research among similar candidates.
                  </span>
                </div>
                <div className={styles.insightRow}>
                  <span className={styles.insightDot}>✓</span>
                  <span>
                    Strong fit for <b>cross-functional</b> design teams.
                  </span>
                </div>
                <div className={styles.insightRow}>
                  <span
                    className={`${styles.insightDot} ${styles.insightDotWarn}`}
                  >
                    !
                  </span>
                  <span>
                    Growth area: <b>stakeholder communication</b>.
                  </span>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </header>
  );
}
